import * as React from "react";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { setEditableFields } from "../../../../redux/reducers/MembersPortalReducer";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { ADD_NEW_ACTION, DRAFT_AGREEMENTS_APPLICABLE_WORKS_STATE_KEY, REPERTOIRE } from "../../../Consts";
import { hideModal, showUpdateFieldsModal } from "../../../../redux/reducers/ModalReducer";
import DataGridTable from "../../../../repertoire/components/dataGridTable/DataGridTable";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { IAgreementState, IAgreementStateKeys } from "../../../../redux/types/IAgreementState";
import { SEARCH_VIEW } from "../../../../repertoire/Consts";
import { IWorksSearchQuery } from "../../../../repertoire/types/IWorksSearchQuery";
import { FormatFields } from "../../../../redux/types/FormatFields";
import { IMembersPortalField } from "../../../types/IMembersPortalField";

export interface IDraftAgreementsMaintenanceApplicableWorksViewProps {
    dataGridTableData?: IRepertoireComponentDataItem;
    draftAgreementMaintenanceGridsViewData?: IMembersPortalComponentDataItem;
    agreements: IAgreementState;
    isReadonly: boolean;
    lookupValues: ILookupDictionary;
    updateDraftAgreementField: (value: any, fieldName: IAgreementStateKeys, index?: number) => void;
    resetMessageBanner: () => void;
    changesMade: boolean;
    showUpdateFieldsModal?: typeof showUpdateFieldsModal;
    editableFieldsDataView?: IMembersPortalComponentDataItem;
    dataGridTableEditableFieldsData?: IMembersPortalComponentDataItem;
    setEditableFields?: typeof setEditableFields;
    activeTab: number;
    tabs: ITabReduxItem[];
    showModal?: (
        modalContent: string,
        modalComponentInstance: string,
        modalProps: any,
        displayModalCloseButton: boolean,
        title: string,
        modalMessage?: string,
        isReadOnly?: boolean,
        key?: string,
        index?: number

    ) =>void;
    hideModal?: typeof hideModal;
    incrementTempID?: () => void;
    activeHeaderSection?: string;
    isMandatory?: boolean;
    searchWorks?: (query: IWorksSearchQuery, modalOpen: boolean) => void;
    updateDraftAgreementWorkField?:(value: any, fieldName: IAgreementStateKeys, index?: number)=>void;
    getDraftAgreementWorkDetails?: (dataSource: string, workID: number, lookupValues: ILookupDictionary, draftAgreementMaintenanceGridsViewData: IMembersPortalComponentDataItem, formats?: FormatFields[]) => void;
}

interface IDraftAgreementsMaintenanceApplicableWorksViewState {
    loaded: boolean;
    activeHeaderSection?: string;
}

export default class DraftAgreementsMaintenanceApplicableWorksView extends React.PureComponent<
    IDraftAgreementsMaintenanceApplicableWorksViewProps,
    IDraftAgreementsMaintenanceApplicableWorksViewState> {
    viewData;
    constructor(props: IDraftAgreementsMaintenanceApplicableWorksViewProps) {
        super(props);

        this.state = {
            activeHeaderSection: props.activeHeaderSection ?? "draftAgreementsApplicableWorks",
            loaded: false
        };
        this.viewData = {};
    }

    onClickHeaderSection = (activeHeaderSection: string) => {
        this.setState({
            activeHeaderSection
        });
    };

    renderGridViewHeaderSections = (header: IMembersPortalField) => {

        return (
            <div
                className={["headerSection", "activeSection"].join(" ")}
                key={header.name}
                data-testid={header.name + "-section"}
            >
                {header.data}
            </div>
        );
    };


    showFieldsModal = () => {

    }

    render() {
        const {
            isReadonly,
            lookupValues,
            updateDraftAgreementField,
            incrementTempID,
            dataGridTableData,
            draftAgreementMaintenanceGridsViewData,
            tabs,
            activeTab,
            showModal,
            agreements,
            searchWorks,
            updateDraftAgreementWorkField,
            getDraftAgreementWorkDetails
        } = this.props;

        const changeData = (value: any, fieldName: string) => {
            if(fieldName==='draftAgreementsApplicableWorks'){
                updateDraftAgreementField(value, 'agreementWorks');
            }else{
                updateDraftAgreementField(value, fieldName as IAgreementStateKeys);
            }
            
        }

        const openNewTab = (openItem?:any) =>{
            if (openItem["workID"] != undefined) {
                this.props.getDraftAgreementWorkDetails(REPERTOIRE, openItem["workID"],lookupValues,draftAgreementMaintenanceGridsViewData);
            }
        }

        const showSearchModal = (modalProps: any, searchViewKey: string) => {
            const { showModal } = this.props;
            showModal(SEARCH_VIEW, searchViewKey, modalProps, true, "Search");
        };
        return (
            <>
                <div className="topMargin">
                    <div className="row">
                        <div className="headerContainer">
                         {this.renderGridViewHeaderSections(draftAgreementMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'draftAgreementsApplicableWorks'))}
                            
                        
                        </div>
                    </div>
                        {<DataGridTable
                            tableContents={agreements ? agreements.agreementWorks : []}
                            changeData={changeData}
                            dataGridTableData={dataGridTableData}
                            stateKey={DRAFT_AGREEMENTS_APPLICABLE_WORKS_STATE_KEY}
                            componentInstance={DRAFT_AGREEMENTS_APPLICABLE_WORKS_STATE_KEY}
                            showRowNumber={false}
                            isReadOnly={isReadonly}
                            tableActions={isReadonly ? [] : [{ name: ADD_NEW_ACTION }]}
                            lookupValues={lookupValues}
                            incrementTempID={incrementTempID}
                            tabs={tabs}
                            activeTab={activeTab}
                            showDropdownsAsCodes={false}  
                            showModal={showModal} 
                            searchWorks={searchWorks}  
                            updateDraftAgreementWorkField={updateDraftAgreementWorkField}    
                            openInNewTab={openNewTab}                        
                        />}
                </div>
            </>
        );
    }
}